import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

interface Props {
  onSelect: (address: string) => void;
}

export type AddressSearchHandle = { open: () => void; isOpen: boolean };

export const AddressSearch = forwardRef<AddressSearchHandle, Props>((props, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  useImperativeHandle(ref, () => ({
    open() {
      open();
    },
    isOpen,
  }));

  useEffect(() => {
    loadScript();
  }, []);

  const loadScript = () => {
    if (document.querySelector('daum-api')) {
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.charset = 'UTF-8';
    script.id = 'daum-api';
    document.head.append(script);
    // script.onload = () => {};
  };

  const open = () => {
    new window.daum.Postcode({
      oncomplete: (data: any) => {
        // eslint-disable-next-line react/prop-types
        props.onSelect(data?.address);
      },
      onClose: () => {
        setIsOpen(false);
      },
    }).open();
    setIsOpen(true);
  };

  return null;
});

AddressSearch.displayName = 'AddressSearch';
